// export function cookieConent() {
//   (function () {
//     console.log("running");
//     // ── storage keys ───────────────────────────────────────────
//     const STORE_KEY = "cookiePrefs.v1"; // localStorage
//     const CONSENT_COOKIE = "cookiesConsent"; // "yes" | "no" | "custom" (for legacy checks)
//     const AGE_COOKIE = "age-verification-yes"; // set by your age gate

//     // ── defaults ───────────────────────────────────────────────
//     const defaultPrefs = {
//       necessary: true, // always on
//       analytics: false,
//       functional: false,
//       marketing: false,
//       timestamp: null,
//     };

//     // ── DOM ────────────────────────────────────────────────────
//     const root = document.getElementById("cc-banner");
//     if (!root) return; // nothing to do if banner not in DOM

//     const step1 = root.querySelector(".cc__panel--step1");
//     const step2 = root.querySelector(".cc__panel--step2");

//     // ── helpers: storage & cookies ─────────────────────────────
//     function getPrefs() {
//       try {
//         const raw = localStorage.getItem(STORE_KEY);
//         return raw ? { ...defaultPrefs, ...JSON.parse(raw) } : null;
//       } catch {
//         return null;
//       }
//     }

//     function setPrefs(p) {
//       const val = { ...p, necessary: true, timestamp: Date.now() };
//       try {
//         localStorage.setItem(STORE_KEY, JSON.stringify(val));
//       } catch {}
//       // also reflect a coarse overall state in a cookie for legacy code/SSR
//       const coarse = val.analytics || val.functional || val.marketing ? (val.analytics && val.functional && val.marketing ? "yes" : "custom") : "no";
//       setCookie(CONSENT_COOKIE, coarse, 365);
//       return val;
//     }

//     function setCookie(name, value, days) {
//       const maxAge = days ? days * 24 * 60 * 60 : undefined;
//       document.cookie =
//         `${name}=${encodeURIComponent(value)}; Path=/; SameSite=Lax;` +
//         (location.protocol === "https:" ? " Secure;" : "") +
//         (maxAge ? ` Max-Age=${maxAge};` : "");
//     }

//     function getCookie(name) {
//       return document.cookie
//         .split("; ")
//         .find((c) => c.startsWith(name + "="))
//         ?.split("=")[1];
//     }

//     function hasAge() {
//       return getCookie(AGE_COOKIE) === "true" || window.__ageVerifiedOnce === true;
//     }

//     // ── UI show/hide/steps ─────────────────────────────────────
//     let opened = false;
//     let _prevFocus = null;

//     function showStep(n) {
//       // clear both
//       [step1, step2].forEach((p) => {
//         if (!p) return;
//         p.classList.remove("is-active");
//         p.setAttribute("aria-hidden", "true");
//       });

//       // activate requested
//       const active = n === 1 ? step1 : step2;
//       if (active) {
//         active.classList.add("is-active");
//         active.setAttribute("aria-hidden", "false");
//       }
//     }

//     function show(isBtnClick) {
//       // ensure only step 1 is visible when opening

//       function showActions() {
//         showStep(1);

//         root.classList.remove("is-hidden");

//         // remember where focus was
//         _prevFocus = document.activeElement;

//         // make the container focusable just for this moment
//         root.setAttribute("tabindex", "-1");
//         root.setAttribute("role", "dialog");
//         root.setAttribute("aria-modal", "true");

//         // focus the container (so the next Tab goes to the first control)
//         try {
//           root.focus({ preventScroll: true });
//         } catch {}
//       }
//       if (isBtnClick) {
//         showActions();
//       } else {
//         setTimeout(() => {
//           showActions();
//         }, 5000);
//       }
//     }

//     function hide() {
//       root.classList.add("is-hidden");
//       opened = false;

//       // clean up the temporary tabindex so it’s not in the tab order forever
//       root.removeAttribute("tabindex");
//       root.removeAttribute("aria-modal");

//       // restore focus to where the user was (if still in DOM)
//       if (_prevFocus && document.contains(_prevFocus)) {
//         try {
//           _prevFocus.focus({ preventScroll: true });
//         } catch {}
//       }
//     }

//     // hydrate toggles from prefs (step 2)
//     function hydrateToggles(p = getPrefs() || defaultPrefs) {
//       ["analytics", "functional", "marketing"].forEach((k) => {
//         root.querySelectorAll(`[data-pref="${k}"]`).forEach((el) => {
//           if ("checked" in el) el.checked = !!p[k];
//           else el.setAttribute("aria-pressed", p[k] ? "true" : "false");
//         });
//       });
//     }

//     // collect from toggles
//     function collectToggles() {
//       const prefs = {
//         necessary: true,
//         analytics: !!root.querySelector('[data-pref="analytics"]')?.checked,
//         functional: !!root.querySelector('[data-pref="functional"]')?.checked,
//         marketing: !!root.querySelector('[data-pref="marketing"]')?.checked,
//       };
//       return setPrefs(prefs);
//     }

//     // ── actions ────────────────────────────────────────────────
//     function acceptAll() {
//       const p = setPrefs({ necessary: true, analytics: true, functional: true, marketing: true });
//       hide();
//       dispatchConsent(p);
//     }

//     function strictOnly() {
//       const p = setPrefs({ necessary: true, analytics: false, functional: false, marketing: false });
//       hide();
//       dispatchConsent(p);
//     }

//     function saveCustom() {
//       const p = collectToggles();
//       hide();
//       dispatchConsent(p);
//     }

//     function dispatchConsent(detail) {
//       // notify both targets (avoid mismatch)
//       const evt = new CustomEvent("cookie:consent", { detail });
//       document.dispatchEvent(evt);
//       try {
//         window.dispatchEvent(evt);
//       } catch {}
//     }

//     // ── wire buttons (event delegation) ────────────────────────
//     root.addEventListener("click", (e) => {
//       const t = e.target.closest("[data-cc]");
//       if (!t) return;
//       const a = t.getAttribute("data-cc");

//       switch (a) {
//         case "accept-all":
//           acceptAll();
//           break;
//         case "decline":
//         case "strict-only":
//           strictOnly();
//           break;
//         case "customize":
//           hydrateToggles();
//           showStep(2);
//           break;
//         case "save-prefs":
//           saveCustom();
//           break;
//         case "back":
//           showStep(1);
//           break;
//       }
//     });

//     // ── initial state / appearance logic ───────────────────────
//     // If user already decided, keep hidden.
//     const existing = getPrefs();
//     if (existing) {
//       // ensure toggles reflect stored values when user reopens (if you expose an “edit cookies” link)
//       hydrateToggles(existing);
//       hide();
//     } else {
//       // wait for age verification, or show if already verified
//       const tryOpen = () => {
//         if (!opened && !getPrefs() && hasAge()) {
//           hydrateToggles();
//           // small delay to avoid clashing with age modal fade-out
//           setTimeout(show, 100);
//         }
//       };

//       // listen on both document and window + both event names you use elsewhere
//       const openOnce = () => {
//         window.__ageVerifiedOnce = true;
//         tryOpen();
//       };
//       window.addEventListener("age:verified", openOnce, { once: true });
//       document.addEventListener("age:verified", openOnce, { once: true });
//       window.addEventListener("ageVerification:accept", openOnce, { once: true });
//       document.addEventListener("ageVerification:accept", openOnce, { once: true });

//       // if the cookie is already present (deep refresh) open after load
//       if (hasAge()) {
//         if (document.readyState === "loading") {
//           document.addEventListener("DOMContentLoaded", tryOpen, { once: true });
//         } else {
//           tryOpen();
//         }
//       }
//     }

//     // ── optional: expose an opener so you can show banner from a footer link ──
//     window.openCookieConsent = function (isBtnClick = false) {
//       hydrateToggles(getPrefs() || defaultPrefs);
//       showStep(getPrefs() ? 2 : 1);
//       show(isBtnClick);
//     };

//     // ── optional: helper to check a category anywhere in the app ─────────────
//     window.cookieAllowed = function (category) {
//       const p = getPrefs();
//       if (!p) return false;
//       if (category === "necessary") return true;
//       return !!p[category];
//     };
//   })();
// }

export function cookieConent() {
  (function () {
    // ── GTM bootstrap (safe even if GTM loads later) ───────────
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments);
      };

    // Send a Consent Mode v2 DEFAULT (deny non-essential) ASAP
    // Note: security_storage must remain granted.
    gtag("consent", "default", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
      functionality_storage: "denied",
      security_storage: "granted",
    });

    // Also publish a coarse default for non-Google tags in GTM
    window.dataLayer.push({
      event: "cookie_consent_default",
      consent: { analytics: false, functional: false, marketing: false, necessary: true },
    });

    // ── storage keys ───────────────────────────────────────────
    const STORE_KEY = "cookiePrefs.v1"; // localStorage
    const CONSENT_COOKIE = "cookiesConsent"; // 'yes'|'no'|'custom' for legacy checks
    const AGE_COOKIE = "age-verification-yes"; // set by your age gate

    // ── defaults ───────────────────────────────────────────────
    const defaultPrefs = {
      necessary: true,
      analytics: false,
      functional: false,
      marketing: false,
      timestamp: null,
    };

    // ── DOM ────────────────────────────────────────────────────
    const root = document.getElementById("cc-banner");
    if (!root) return;

    const step1 = root.querySelector(".cc__panel--step1");
    const step2 = root.querySelector(".cc__panel--step2");

    // ── helpers: storage & cookies ─────────────────────────────
    function getPrefs() {
      try {
        const raw = localStorage.getItem(STORE_KEY);
        return raw ? { ...defaultPrefs, ...JSON.parse(raw) } : null;
      } catch {
        return null;
      }
    }
    window.getCookiePrefs = getPrefs; // handy for GTM variables if you want

    function setCookie(name, value, days) {
      const maxAge = days ? days * 24 * 60 * 60 : undefined;
      document.cookie =
        `${name}=${encodeURIComponent(value)}; Path=/; SameSite=Lax;` +
        (location.protocol === "https:" ? " Secure;" : "") +
        (maxAge ? ` Max-Age=${maxAge};` : "");
    }
    function getCookie(name) {
      return document.cookie
        .split("; ")
        .find((c) => c.startsWith(name + "="))
        ?.split("=")[1];
    }
    function hasAge() {
      return getCookie(AGE_COOKIE) === "true" || window.__ageVerifiedOnce === true;
    }

    function setPrefs(p) {
      const val = { ...p, necessary: true, timestamp: Date.now() };
      try {
        localStorage.setItem(STORE_KEY, JSON.stringify(val));
      } catch {}
      // Legacy coarse cookie (optional)
      const coarse = val.analytics || val.functional || val.marketing ? (val.analytics && val.functional && val.marketing ? "yes" : "custom") : "no";
      setCookie(CONSENT_COOKIE, coarse, 365);
      return val;
    }

    // Map our prefs -> Consent Mode signals
    function mapToGtagConsent(p) {
      return {
        ad_storage: p.marketing ? "granted" : "denied",
        ad_user_data: p.marketing ? "granted" : "denied",
        ad_personalization: p.marketing ? "granted" : "denied",
        analytics_storage: p.analytics ? "granted" : "denied",
        functionality_storage: p.functional ? "granted" : "denied",
        security_storage: "granted",
      };
    }

    // Push a GTM event + Consent Mode update
    function broadcastConsent(prefs) {
      const consent = {
        analytics: !!prefs.analytics,
        functional: !!prefs.functional,
        marketing: !!prefs.marketing,
        necessary: true,
      };

      // DataLayer event for GTM triggers/variables
      window.dataLayer.push({
        event: "cookie_consent_update",
        consent,
      });

      // Consent Mode v2 update for Google tags
      gtag("consent", "update", mapToGtagConsent(prefs));

      // App-level event (if anything else listens)
      const evt = new CustomEvent("cookie:consent", { detail: prefs });
      document.dispatchEvent(evt);
      try {
        window.dispatchEvent(evt);
      } catch {}
    }

    // ── UI show/hide/steps ─────────────────────────────────────
    let opened = false;
    let _prevFocus = null;

    function showStep(n) {
      [step1, step2].forEach((p) => {
        if (!p) return;
        p.classList.remove("is-active");
        p.setAttribute("aria-hidden", "true");
      });
      const active = n === 1 ? step1 : step2;
      if (active) {
        active.classList.add("is-active");
        active.setAttribute("aria-hidden", "false");
      }
    }

    function show(isBtnClick) {
      const run = () => {
        showStep(1);
        // force style/reflow before removing .is-hidden if needed:
        // void root.offsetWidth;
        root.classList.remove("is-hidden");

        _prevFocus = document.activeElement;
        root.setAttribute("tabindex", "-1");
        root.setAttribute("role", "dialog");
        root.setAttribute("aria-modal", "true");
        try {
          root.focus({ preventScroll: true });
        } catch {}
        opened = true;
      };
      if (isBtnClick) run();
      else setTimeout(run, 5000);
    }

    function hide() {
      root.classList.add("is-hidden");
      opened = false;
      root.removeAttribute("tabindex");
      root.removeAttribute("aria-modal");
      if (_prevFocus && document.contains(_prevFocus)) {
        try {
          _prevFocus.focus({ preventScroll: true });
        } catch {}
      }
    }

    // hydrate toggles from prefs (step 2)
    function hydrateToggles(p = getPrefs() || defaultPrefs) {
      ["analytics", "functional", "marketing"].forEach((k) => {
        root.querySelectorAll(`[data-pref="${k}"]`).forEach((el) => {
          if ("checked" in el) el.checked = !!p[k];
          else el.setAttribute("aria-pressed", p[k] ? "true" : "false");
        });
      });
    }

    // collect from toggles
    function collectToggles() {
      const prefs = {
        necessary: true,
        analytics: !!root.querySelector('[data-pref="analytics"]')?.checked,
        functional: !!root.querySelector('[data-pref="functional"]')?.checked,
        marketing: !!root.querySelector('[data-pref="marketing"]')?.checked,
      };
      return setPrefs(prefs);
    }

    // ── actions ────────────────────────────────────────────────
    function acceptAll() {
      const p = setPrefs({ necessary: true, analytics: true, functional: true, marketing: true });
      hide();
      broadcastConsent(p);
    }
    function strictOnly() {
      const p = setPrefs({ necessary: true, analytics: false, functional: false, marketing: false });
      hide();
      broadcastConsent(p);
    }
    function saveCustom() {
      const p = collectToggles();
      hide();
      broadcastConsent(p);
    }

    // ── wire buttons ───────────────────────────────────────────
    root.addEventListener("click", (e) => {
      const t = e.target.closest("[data-cc]");
      if (!t) return;
      const a = t.getAttribute("data-cc");
      switch (a) {
        case "accept-all":
          acceptAll();
          break;
        case "decline":
        case "strict-only":
          strictOnly();
          break;
        case "customize":
          hydrateToggles();
          showStep(2);
          break;
        case "save-prefs":
          saveCustom();
          break;
        case "back":
          showStep(1);
          break;
      }
    });

    // optional footer link opener
    document.getElementById("footer-cookies-customize")?.addEventListener("click", (e) => {
      e.preventDefault();
      window.openCookieConsent(true);
    });

    // ── initial state / appearance logic ───────────────────────
    const existing = getPrefs();
    if (existing) {
      // reflect to toggles and GTM immediately (so refresh respects prior choice)
      hydrateToggles(existing);
      // Publish current consent on load so GTM can honor it without waiting for clicks
      broadcastConsent(existing);
      hide();
    } else {
      // wait for age verification, or show if already verified
      const tryOpen = () => {
        if (!opened && !getPrefs() && hasAge()) {
          hydrateToggles();
          setTimeout(show, 100);
        }
      };
      const openOnce = () => {
        window.__ageVerifiedOnce = true;
        tryOpen();
      };
      window.addEventListener("age:verified", openOnce, { once: true });
      document.addEventListener("age:verified", openOnce, { once: true });
      window.addEventListener("ageVerification:accept", openOnce, { once: true });
      document.addEventListener("ageVerification:accept", openOnce, { once: true });

      if (hasAge()) {
        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", tryOpen, { once: true });
        } else {
          tryOpen();
        }
      }
    }

    // Public API
    window.openCookieConsent = function (isBtnClick = false) {
      hydrateToggles(getPrefs() || defaultPrefs);
      showStep(getPrefs() ? 2 : 1);
      show(isBtnClick);
    };
    window.cookieAllowed = function (category) {
      const p = getPrefs();
      if (!p) return false;
      if (category === "necessary") return true;
      return !!p[category];
    };
  })();
}
